import React, { useEffect, useState } from "react";
import { useRouter } from "next/router";
import { GridColumn } from "emotion-flex-grid";
import { useDispatch, useSelector } from "react-redux";

import { getCard, addCard, setCretorPaymentCard } from "store/paymentReducer/paymentActions";
import { getBuyerCard, getCreatorCard } from "api/api";

import HeadTitle from "components/HeadTitle";
import Menu from "components/Menu";
import { Container, Row, Content, ErrorSettingsContainer } from "styles/App.styled";
import Info from "components/Settings/YourInfo";

import Tabs from "components/Tabs";

import { WithLogin } from "HOC/WithLogin";
import { Title } from "components/Settings/styled";
import Router from "next/router";
import { clearErrors, getServerErrors } from "../../store/alert";
import { getOwner } from "store/userReducer/userSelectors";
import dynamic from "next/dynamic";
const Dialog = dynamic(() => import("shared/Dialog"), { ssr: false });
const CustomUrl = dynamic(() => import("shared/CommonForm/CustomUrl"), { ssr: false });
const Payment = dynamic(() => import("components/Settings/Payment"), { ssr: false });
const Payout = dynamic(() => import("components/Settings/Payout"), { ssr: false });
const ConnectSocial = dynamic(() => import("components/Settings/ConnectSocial"), { ssr: false });
const ChangePassword = dynamic(() => import("components/Settings/ChangePassword"), { ssr: false });
const BecomeCreator = dynamic(() => import("components/Settings/BecomeCreator"), { ssr: false });

const Settings = () => {
  const router = useRouter();
  const [tab, setTab] = useState(router?.query?.addPaymentMethod ? 6 : 1);
  const user = useSelector(getOwner);
  const serverErrors = useSelector(getServerErrors);
  const dispatch = useDispatch();

  useEffect(() => {
    if (router?.query?.onBord) {
      const stripeData = JSON.parse(localStorage.getItem("creator_stripe"));
      if (stripeData) {
        dispatch(
          addCard({
            id: stripeData.id,
            number: `**** **** **** ${stripeData.last4}`,
            date: `${stripeData.exp_month}/${stripeData.exp_year}`,
            type: stripeData.brand,
            name: stripeData.name,
            is_buyer: false,
            stripe_account_id: stripeData.account,
            callback: () => {
              Router.replace("/settings");
            },
          })
        );
      }
    } else if (router?.query?.becomeCreator) {
      setTab(7);
    } else if (router?.query?.addPaymentMethod) {
      setTab(6);
    }
  }, []);

  const tabNavList = [
    {
      id: 1,
      text: "Personal Info",
    },
    {
      id: 2,
      text: "Custom URL",
    },
    {
      id: 3,
      text: "Connect Social Accounts",
    },
    {
      id: 4,
      text: "Change Password",
    },
    {
      id: 5,
      text: "Payment",
    },
    {
      id: 6,
      text: "Payout",
      onlyCreator: true,
    },
    {
      id: 7,
      text: "Become a Creator",
      onlyBuyer: true,
    },
  ];
  const tabContent = [
    {
      id: 1,
      content: <Info name="John Smith" />,
    },
    {
      id: 2,
      content: <CustomUrl />,
    },
    {
      id: 3,
      content: <ConnectSocial />,
    },
    {
      id: 4,
      content: <ChangePassword />,
    },
    {
      id: 5,
      content: <Payment user={user} />,
    },
    {
      id: 6,
      content: <Payout setTab={setTab} />,
      onlyCreator: true,
    },
    {
      id: 7,
      content: <BecomeCreator />,
      onlyBuyer: true,
    },
  ];

  useEffect(() => {
    if (user.is_creator) {
      dispatch(setCretorPaymentCard());
      if (user.creator_payout_method_connected) {
        dispatch(getCard({ request: getCreatorCard, is_buyer: !user.is_creator }));
      }
    } else if (!user.is_creator && user.buyer_payment_method_connected)
      dispatch(getCard({ request: getBuyerCard, is_buyer: !user.is_creator }));
  }, [user.id]);

  return (
    <>
      <HeadTitle title={"Foody | Settings"} />
      <Container>
        <GridColumn pt={["xl", "xl3"]} pb={["xl6", "xxl2"]}>
          <Row>
            <Menu />
            <Content>
              <Title className="profile">Settings</Title>
              <ErrorSettingsContainer>
                <Dialog
                  state={serverErrors}
                  type="error"
                  onClose={() => {
                    dispatch(clearErrors());
                  }}
                />
              </ErrorSettingsContainer>
              <Tabs
                list={!user.is_creator ? tabNavList.filter((item) => !item.onlyCreator) : tabNavList}
                tabContent={!user.is_creator ? tabContent.filter((item) => !item.onlyCreator) : tabContent}
                active={tab}
                setTab={setTab}
                tabType="tabType1"
                canChangeTab={true}
              />
            </Content>
          </Row>
        </GridColumn>
      </Container>
    </>
  );
};

export default WithLogin(Settings);
